module.exports = __webpack_public_path__ + "static/media/日历4@2x.ff8929fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历4@2x.png
// module id = 1377
// module chunks = 0